
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promocoes-do-ano/[landingSlug]/[categorySlug]",
      function () {
        return require("private-next-pages/promocoes-do-ano/[landingSlug]/[categorySlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promocoes-do-ano/[landingSlug]/[categorySlug]"])
      });
    }
  